<script lang="ts">
    import { spaNavigate } from "../../../actions"
    import { actionApproval } from "../../../store"
    import Cta from "../../CTA.svelte"
    export let type: TaskTypes, gridview: boolean, taskId: string, orderId: string

    let outerWidth: number
    const gridBreakPoint = 1200
    $: gridview = outerWidth <= gridBreakPoint
</script>

<svelte:window bind:innerWidth="{outerWidth}" />
{#if gridview}
    <div class="row-wrapper">
        <div>
            {#if type == "oilSpillRemoval"}
                <img
                    src="../../../../../assets/icons/solar_waterdrops-outline-white.svg"
                    alt="oil spill"
                />
                <span>Ölwehrauftrag</span>
            {:else if type == "towing"}
                <img
                    src="../../../../../assets/icons/hugeicons_tow-truck-white.svg"
                    alt="tow truck"
                /><span> Abschleppauftrag </span>
            {/if}
        </div>
        <Cta
            type="BubbleButton"
            icon="solar_arrow-right-outline"
            content="zum Einsatz"
            on:click="{() => {
                $actionApproval = {
                    modalTitle: 'Einsatz bearbeiten',
                    modalText: 'Möchten sie den Einsatz bearbeiten?',
                    callback: () => spaNavigate(`/order/${orderId}/task/${taskId}`),
                }
            }}"
        />
    </div>
{:else if type == "oilSpillRemoval"}
    <img
        src="../../../../../assets/icons/solar_waterdrops-outline.svg"
        alt="oil spill"
    />
{:else if type == "towing"}
    <img
        src="../../../../../assets/icons/hugeicons_tow-truck.svg"
        alt="tow truck"
    />
{/if}

<style lang="less">
    .row-wrapper {
        display: flex;
        width: 100%;
        justify-content: space-between;
        & > div {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            span {
                font-weight: 700;
                color: white;
            }
        }
    }
</style>
